<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="卡号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native='getAgentTopUpOrderListHandle' clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native='getAgentTopUpOrderListHandle' clearable></el-input>
            </el-form-item>
            <el-form-item label="订单状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option v-for="item in orderState" :key="item.description" :label="item.description" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单来源：">
                <el-select v-model="searchForm.createType" clearable>
                    <el-option v-for="item in typeEnum" :key="item.description" :label="item.description" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button plain icon="el-icon-search" type="primary" @click="getAgentTopUpOrderListHandle">查询</el-button>
<!--                 <el-button type="success" @click="confirmExportDialogVisible = true">导出Excel</el-button>
 -->            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData"
		  border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column prop="orderNo" label="订单号" width="170" align="center"></el-table-column>
            <el-table-column prop="agentPathNames" label="所属代理商" width="100" align="center"></el-table-column>
            <el-table-column label="ICCID号" width="160" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
             <el-table-column  align="center"  label="套餐名称" >
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.commissionRmb">
                        <p style="color:#5c7eff"> {{scope.row.packageName}}</p>
                    </el-tooltip> 
                </template> 
            </el-table-column>
            <el-table-column prop="priceRmb" label="金额(元)"  align="center"></el-table-column>
             <el-table-column  align="center"  label="支付状态" >
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.payState==1" class="item" effect="dark" :content="scope.row.orderNo">
                        <p style="color:green"> {{scope.row.payStateName}}</p>
                    </el-tooltip>
                  <el-tooltip v-else-if="scope.row.payState==3||scope.row.payState==4" class="item" effect="dark" :content="scope.row.orderNo">
                        <p style="color:red"> {{scope.row.payStateName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.orderNo">
                        <p style="color:teal"> {{scope.row.payStateName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
             <el-table-column prop="backPriceRmb" label="退款金额"  align="center"></el-table-column>
             
            <el-table-column prop="createTypeName" label="订单来源"  align="center"></el-table-column>
            <el-table-column prop="supplierName" label="供应商"  align="center"></el-table-column>
            <el-table-column prop="createTime"  label="下单时间" width="150" align="center"></el-table-column>
              <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showBackMoneyDialog(scope.row)" v-if="scope.row.payState==1 && scope.row.createType != 0 && scope.row.createType != 4 && scope.row.createType != 5 ">
						<span style="color: red;">
							申请退款
						</span>
					</el-button>
                </template>                
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            background layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>   

<el-dialog :append-to-body="true"  title="退款申请" :visible.sync="backMoneyDialogVisible" width="600px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订&nbsp;单&nbsp;号：</label>
                <span>{{rowData.orderNo}}</span>
            </div>
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{rowData.iccid}}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{rowData.priceRmb}} 元</span>
            </div>

            <div class="lineInDialog">
                <label class="label-defined">付款凭证：</label>
                <div class="many">                    
                    <div class="uploadOuter">
                        <input type="file"  @change="showImg($event, 'existImg', 'payImg')" >
                        <div v-if="!existImg">点击上传付款凭证</div>
                        <img v-else :src="payImg" alt="">  
                    </div>
                </div>
            </div>
            <div class="lineInDialog">
                <label>退款原因：</label>
                <el-input  type="textarea" placeholder="请输入内容" :rows="5" v-model.trim="backMoneyForm.remark" clearable></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelToBackMoney">取 消</el-button>
                <el-button type="primary" @click="handleBackMoney">申 请</el-button>
            </span>            
        </el-dialog>
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportOrderInfoHandle">确 定</el-button>
            </span>
        </el-dialog>    
    </div>
</template>
<script>
import {getAgentTopUpOrderList, getSecondBackList,exportOrderInfo, getOrderStateList, getOrderSourceList, backMoney, backMoneyDetail,resetOrderState} from '@/api/order.js'
import common from '@/utils/common.js'

export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                supplierCode: '',
                iccid: '',
                orderNo: '',
                investType: '',
                time: '',
                payState: '',
                createType: ''
            },
            typeEnum: [
                {
                    code:0,
                    description:'平台充值'
                },
                  {
                    code:1,
                    description:'代理商充值'
                },
                  {
                    code:6,
                    description:'API接口订单'
                }
            ],
            orderState: [],
            orderSource: [],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            confirmExportDialogVisible:false,
            orderDetailVisible: false,
            orderDetailForm: {},
            branchSupplierOption: [],
            currentOrderNo_back: '',
            tbpg_back: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },
              backMoneyForm:{},
               formDate:{},
                 backMoneyDialogVisible:false,
            rowData:{},
             existImg:false,
            payImg:'',

        }
    },
    methods: {
          //“退款操作” 对话框
        showBackMoneyDialog(row){


               this.$confirm('每笔订单只能申请一次退款。确定提交退款申请吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
              this.backMoneyDialogVisible = true;
            this.rowData = row;
            }).catch(() => {

            });
            
        },
          handleBackMoney(){
            if(this.backMoneyForm.remark == ''){
                this.$message.error('请先输入退款原因！');
                return;
            }
            this.formDate.append('orderId', this.rowData.orderNo);
            this.formDate.append('rqReason', this.backMoneyForm.remark);

            this.$confirm('确定提交退款申请吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                backMoney(this.formDate).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                    }else{
                        this.$message.error(res.data.message)
                    }

                    this.formDate.delete('payImg');
                    this.formDate.delete('orderId');
                    this.formDate.delete('rqReason');
                    this.rowData.id = '';
                    this.backMoneyForm.remark = '';
                    this.payImg = '';
                    this.existImg = false;
                    this.backMoneyDialogVisible = false;

                    this.getAgentTopUpOrderListHandle();
                });
            }).catch(() => {

            });
            
        },
          showImg(event, showImgkey, imgUrl){
            this.$data[showImgkey] = true;
            this.existImg = true;
            const files = event.target.files;

            let filename = files[0].name          //只有一个文件
            if ( filename.lastIndexOf('.') <= 0 ) {
                return alert("Please add a valid image!")        //判断图片是否有效
            }
            const fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.addEventListener('load',() => {
                this.$data[imgUrl] = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.image = files[0];
            this.formDate.append('payImg', files[0]);
        },
           cancelToBackMoney(){
            this.backMoneyDialogVisible = false;
            this.formDate.delete('payImg');
            this.formDate.delete('orderId');
            this.formDate.delete('rqReason');
            this.rowData.id = '';
            this.backMoneyForm.remark = '';
            this.payImg = '';
            this.existImg = false;
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getAgentTopUpOrderListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getAgentTopUpOrderList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        exportOrderInfoHandle(){
            let _that = this;
            common.deleteSpaceKey(_that.searchForm); 
            exportOrderInfo(_that.searchForm).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去任务中心下载');
                }else{
                    this.$message.error(res.data.msg);
                }
                this.confirmExportDialogVisible = false;
            }).catch(err=>console.error(err));
        },

        handleSizeChange(val){
            if(this.backVisible || this.backMoneyDetailVisible){
                this.tbpg_back.pageSize = val;
                this.showSecondBackList(this.currentOrderNo_back);
            }else{
                this.tbpg.pageSize = val;
                this.getAgentTopUpOrderListHandle();
            }

        },
        handleCurrentChange(val){
            if(this.backVisible){
                this.tbpg_back.currentPage = val;
                this.showSecondBackList(this.currentOrderNo_back);
            }else{
                this.tbpg.currentPage = val
                this.getAgentTopUpOrderListHandle();                
            }
        },

        handleBackMoneyDetail(row){
            let params = {};
            params.id = row.id;
            backMoneyDetail(params).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }
            });
            
        },
        resetOrderStateHandle(row){
            var data = {
                id: row.id,
                payState: 0
            }
            resetOrderState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                    this.getAgentTopUpOrderListHandle();
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },

    },
    created(){
         this.formDate = new FormData();
        this.getAgentTopUpOrderListHandle();
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
        getOrderStateList().then(res => {
            if(res.data.code == 200){
                this.orderState = res.data.data;
            }
        })
        getOrderSourceList().then(res => {
            if(res.data.code == 200){
                this.orderSource = res.data.data;
            }
        })
    }
}
</script>
<style lang="less" scoped>
.label-defined{
        display: inline-block;
        height: 32px;
        line-height: 32px;
    }
     .many {
        display: flex;
        justify-content: space-between;
        label {
            display: block;
            line-height: 36px;
        }
        .uploadOuter {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 180px;
            min-height: 100px;
            max-height: 250px;
            border: 1px dashed #e5e5e5;
            box-sizing: border-box;
            input[type=file] {
                position: absolute;
                top: 0;
                width: 0;
                width: 50%;
                height: 100%;
                opacity: 0;
            }                
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .label-defined{
        display: inline-block;
        height: 32px;
        line-height: 32px;
    }

    .text-align-left{
        text-align:left
    }

    .many {
        display: flex;
        justify-content: space-between;
        label {
            display: block;
            line-height: 36px;
        }
        .uploadOuter {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 180px;
            min-height: 100px;
            max-height: 250px;
            border: 1px dashed #e5e5e5;
            box-sizing: border-box;
            input[type=file] {
                position: absolute;
                top: 0;
                width: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
            }                
            img {
                width: 100%;
                height: 100%;
            }
        }
    }

</style>

